export default __webpack_public_path__ + "static/Resume-300a48c53fe49ed7d4a7f4e0f1fff5c0.pdf";